module.exports = __webpack_public_path__ + "img/celebrate.48b0cb44.svg";